export const config = {
    row: {
        props: {

        },
        style: {
            xs: {
            },
            sm: {
            },
            md: {
            },
            lg: {
            }
        }
    },
    col1: {
        props: {
            span: 8
        },
        style: {
            xs: {
                height: '54px'
            },
            sm: {
                height: '74px'
            },
            md: {
                height: '94px'
            },
            lg: {
                height: '114px',
                display: 'table'
            }
        }
    },
    col2: {
        props: {
            span: 8
        },
        style: {
            xs: {
                height: '54px'
            },
            sm: {
                height: '74px'
            },
            md: {
                height: '94px'
            },
            lg: {
                height: '114px'
            }
        }
    },
    col3: {
        props: {
            span: 8
        },
        style: {
            xs: {
                height: '54px'
            },
            sm: {
                height: '74px'
            },
            md: {
                height: '94px'
            },
            lg: {
                height: '114px'
            }
        }
    }
}
